/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum BillingInterval {
  month = 'month',
  year = 'year',
}

export enum MemberRole {
  admin = 'admin',
  member = 'member',
  owner = 'owner',
}

export interface AcceptOfferInput {
  acceptedAt: string;
  accountId: string;
  offerId: string;
  targetPlanId?: string | null;
  variant: OfferVariantInput;
}

export interface AccountInput {
  companiesTrialAutoUpgrade?: boolean | null;
  dataRetentionDays?: number | null;
  isAutoReplayEnabled?: boolean | null;
  logoChoice?: string | null;
  name?: string | null;
  trialAutoUpgrade?: boolean | null;
}

export interface ChangeAccountPlanInput {
  planId: string;
  downgradeReason?: any | null;
}

export interface OfferCampaignInput {
  id: string;
  maxUses: number;
  name: string;
  slug: string;
}

export interface OfferPlanGroupInput {
  id: string;
  name: string;
}

export interface OfferPlanInput {
  amount: number;
  displayShortName?: string | null;
  id: string;
  interval: string;
  name: string;
}

export interface OfferVariantInput {
  campaign: OfferCampaignInput;
  destinationPlan?: OfferPlanInput | null;
  id: string;
  isControl: boolean;
  monthlyCost: number;
  name: string;
  promotionPlanGroup?: OfferPlanGroupInput | null;
  terms?: string | null;
  totalCost: number;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
